import { BookedBenefitsEnum, PricingModelEnum } from '@pxtra-client-lib-legacy/gen';

export const checkHasCompanyBenefitSets = (
  pricingModel?: PricingModelEnum,
  bookedBenefits?: BookedBenefitsEnum[] | null
) =>
  (!pricingModel?.startsWith('starter_') &&
    pricingModel !== 'bonus_standalone' &&
    pricingModel !== 'basic_light') ||
  (bookedBenefits?.length ?? 0) > 1;

export const checkHasCompanyCustomBenefits = (pricingModel?: PricingModelEnum) =>
  pricingModel === 'starter_plus' ||
  pricingModel === 'basic_light' ||
  (!pricingModel?.startsWith('starter_') && pricingModel !== 'bonus_standalone');
